import $ from "jquery";
import queryString from "query-string";
import Cookies from "js-cookie";
import {
    debounce,
    setAllLikes,
} from "../../../../assets/js/lib/content/helper";
import anime from "animejs";

/**
 * Set filters
 */
let current_filters = queryString.parse(location.search, {
    arrayFormat: "bracket",
});

const filter_url = HOME_URL + "/get-templates/";
let loaded_templates = [];

/**
 * Read current filters
 */
function readCurrentFilter() {
    var template_types = $('input[name="template-types"]:checked')
        .map(function () {
            return this.value;
        })
        .get();

    var template_kinds = $('input[name="template-kinds"]:checked')
        .map(function () {
            return this.value;
        })
        .get();

    // Only set template_periods if template_types contains 'groepsreis'
    var template_periods = null;

    if (template_types.includes("groepsreis")) {
        template_periods = $('input[name="template-periods"]:checked')
            .map(function () {
                return this.value;
            })
            .get();
        $("#filter-block-template-periods").removeClass("s_disabled");
    } else {
        $("#filter-block-template-periods").addClass("s_disabled");
    }

    var days_ranges = $('input[name="days-ranges"]:checked')
        .map(function () {
            return this.value;
        })
        .get();

    var budget_ranges = $('input[name="budget-ranges"]:checked')
        .map(function () {
            return this.value;
        })
        .get();

    current_filters = {
        "template-types": template_types,
        "template-kinds": template_kinds,
        destinations: $("#templates-destinations").val(),
        "days-ranges": days_ranges,
        "budget-ranges": budget_ranges,
        search: $("#templates-search-input").val(),
        view: $("#view").val(),
    };

    // Only add template-periods if it's not null
    if (template_periods !== null) {
        current_filters["template-periods"] = template_periods;
    }
}

/**
 * Set posts query - function
 */
let currentRequest = null;
async function setTemplatesQuery() {
    readCurrentFilter();
    let query_url =
        filter_url +
        "?" +
        queryString.stringify(current_filters, { arrayFormat: "bracket" });

    Cookies.set("sb-templates-filter", JSON.stringify(current_filters), {
        expires: 60,
        secure: true,
    });

    // Abort any in-flight request
    if (currentRequest) {
        currentRequest.abort();
    }

    history.pushState(
        { state: 1 },
        document.title,
        "?" + queryString.stringify(current_filters, { arrayFormat: "bracket" })
    );

    // set filter button classes

    // remove exsisting items
    $(".sb_template-item").remove();

    // set page to loading
    $("#templates-btn-is-loading").removeClass("s_is-hidden");
    $("#templates-btn-load-more").addClass("s_is-hidden");

    await doQuerytemplates(query_url, true);
}

/**
 *
 * @param {string} next_link
 * @param {boolean} clear
 */
async function doQuerytemplates(next_link, clear = true) {
    // see if next link is given, otherwise fetch from #templates-next-link value
    next_link = next_link ? next_link : $("#templates-next-link").val();

    // console.debug(next_link);

    $("#templates-next-link").remove();

    if (clear) {
        $("#templates-btn-load-more").addClass("s_hidden");
        $("#templates-next-link").remove();
        $("#templates-placeholder-items").removeClass("s_hidden");
        $("#templates-items").html("");

        // scroll to top
        anime({
            targets: "body, html",
            scrollTop: 0,
            duration: 300,
            easing: "easeInOutQuad",
        });

        loaded_templates = [];

        // Clear any active itinerary points on the map
        dispatchEvent(new CustomEvent("map:clear-itinerary-points"));
        dispatchEvent(new CustomEvent("map:close-point"));
    }

    if (next_link) {
        // // add loading states on templates-btn-load-more
        $("#templates-btn-load-more").attr("disabled", true);
    }

    // hide no result text
    $("#templates-no-result-content").addClass("s_hidden");

    currentRequest = $.ajax({
        url: `${next_link}${
            /\?/g.test(next_link) ? "&" : "?"
        }random=${Date.now()}`,
        method: "GET",
    });

    let content;
    try {
        content = await currentRequest;
    } catch (e) {
        // Request was aborted by a newer filter change
        if (e.statusText === "abort") return;
        throw e;
    } finally {
        currentRequest = null;
    }

    // parse content to json
    content = JSON.parse(content);

    // push to the loaded templates array
    content.templates.forEach((item) => loaded_templates.push(item));

    // console.debug("AJAX templates from server:", content.templates);
    // console.debug("loaded_templates array:", loaded_templates);

    dispatchEvent(
        new CustomEvent("map:update-points", {
            detail: { points: loaded_templates },
        })
    );

    // console.debug("Dispatched map:update-points with", loaded_templates.length, "templates");

    $("#templates-btn-is-loading").addClass("s_is-hidden");
    $("#templates-btn-load-more").removeClass("s_is-hidden");
    $("[data-templates-amount]").removeClass("s_is-hidden");
    $("#templates-placeholder-items").addClass("s_hidden");
    $("body").removeClass("s_is-open_overlay-template-preview");

    // Set fouund templates
    $("[data-templates-amount-text]").text(
        `${content.found_templates} ${
            content.found_templates == 1 ? "reis gevonden" : "reizen gevonden"
        }`
    );

    // Set filter amount
    if (content.set_filters != 0) {
        $("[data-open-filters-overlay]").attr(
            "data-count",
            content.set_filters
        );
    } else {
        $("[data-open-filters-overlay]").removeAttr("data-count");
    }

    if (content.templates.length >= 1) {
        // remove items if "clear" is true
        if (clear) {
            $(".sb_template-item").remove();
        }
        // append items
        $("#templates-items").append(content.slot);
        $("[data-destination-cta]").addClass("s_hidden");

        setAllLikes();
    } else {
        $("#templates-no-result-content").removeClass("s_hidden");

        console.log(current_filters.destinations);

        if (current_filters.destinations == "all") {
            $(`[data-destination-cta="all"]`).removeClass("s_hidden");
        } else {
            $(
                `[data-destination-cta="${current_filters.destinations}"]`
            ).removeClass("s_hidden");
        }
    }

    // remove loading states on templates-btn-load-more
    $("#templates-btn-load-more")
        .removeClass("s_is-loading")
        .attr("disabled", false);

    // more pages? show load more button
    if ($("#templates-next-link").val()) {
        $("#templates-btn-load-more").removeClass("s_hidden");
    } else {
        $("#templates-btn-load-more").addClass("s_hidden");
    }
}

/**
 * Load more button
 */
$("body").on("click tap", "#templates-btn-load-more", function () {
    // console.debug($("#templates-next-link").val());

    $("#templates-btn-is-loading").removeClass("s_is-hidden");
    $("#templates-btn-load-more").addClass("s_is-hidden");

    if ($("#templates-next-link").val()) {
        doQuerytemplates();
    } else {
        readCurrentFilter();
        let query_url =
            filter_url +
            "page/2/?" +
            queryString.stringify(current_filters, { arrayFormat: "bracket" });
        doQuerytemplates(query_url, false);
    }
});

/**
 * Destinations - on change
 */
$("#templates-destinations").on("change", function () {
    $("[data-destination-cta]").addClass("s_hidden");

    const destination = $(this).val();

    if (destination) {
        enableReset();
    }

    // Show the map once a specific destination is picked; fall back to the
    // list when switching back to all destinations. Onder `large` blijft de
    // lijst staan: daar duwt de kaart de reizen uit beeld (zie
    // `page-templates-filter.twig`); de knop "Kaart bekijken" opent hem wel.
    if (destination && destination !== "all") {
        if (!isCompactViewport()) {
            setView("map");
        }
    } else {
        setView("list");
    }

    setTemplatesQuery();
});

/**
 * template types - on change
 * template transportations - on change
 */
const debouncedSetTemplatesQuery = debounce(function () {
    setTemplatesQuery();
}, 500);

$(
    "input[name='template-types'], input[name='template-kinds'], input[name='template-periods'], input[name='days-ranges'], input[name='budget-ranges']"
).on("change", function () {
    updateDropdownValues();
    enableReset();
    debouncedSetTemplatesQuery();
});

/**
 * Button - open filters overlay
 */
$("[data-open-filters-overlay").on("click tap", function () {
    $("html").addClass("s_user-clicked-filters");
});

/**
 * Button - toggle view
 */
$("[data-toggle-view").on("click tap", function () {
    setView();
});

/**
 * Button - Reset
 */
$("[data-reset-all-filters]").on("click tap", function (e) {
    // Update dropdown values before redirecting
    updateDropdownValues();

    window.location.href = PAGE_URL + "?view=" + current_filters["view"];

    Cookies.set("sb-templates-filter", null, {
        expires: 60,
        secure: true,
    });
});

/**
 * Set view
 *
 * @param {"map"|"list"} [target_view] Force a view; omit to toggle the current one.
 */
function setView(target_view) {
    readCurrentFilter();

    const new_view =
        target_view ||
        (current_filters["view"] == "list" ? "map" : "list");

    // Nothing to do if we're already in the requested view
    if (target_view && current_filters["view"] == target_view) {
        return;
    }

    current_filters["view"] = new_view;

    // De wisselknoppen volgen de klasse op <html> (`templates-filter.scss`).
    if (new_view == "map") {
        $("html").addClass("s_view_map").removeClass("s_view_list");
        $("#view").val("map");
        dispatchEvent(new CustomEvent("map:init"));

        // Wait for map to be ready, then dispatch current template points
        window.addEventListener(
            "map:ready",
            () => {
                // Extract current templates from DOM and update map
                const currentTemplates = extractServerRenderedTemplates();
                if (currentTemplates.length > 0) {
                    dispatchEvent(
                        new CustomEvent("map:update-points", {
                            detail: { points: currentTemplates },
                        })
                    );
                }
            },
            { once: true }
        );
    } else {
        $("html").removeClass("s_view_map").addClass("s_view_list");
        $("#view").val("list");
    }

    history.pushState(
        { state: 1 },
        document.title,
        "?" + queryString.stringify(current_filters, { arrayFormat: "bracket" })
    );
}

/**
 * enableReset
 */
function enableReset() {
    $("[data-reset-all-filters]").removeClass("s_hidden");
}

/**
 * hideFilters
 */
function hideFilters() {
    $("html").removeClass("s_user-clicked-filters");
}

/**
 * Overlay backdrop click
 */
$("body").on("click tap", "[data-close-filters-overlay]", function (e) {
    hideFilters();
});

$(document).on("keydown", function (e) {
    // console.debug(e);
    if (e.code === "Escape") {
        hideFilters();
    }
});

/**
 * Extract server-rendered template data from DOM
 */
function extractServerRenderedTemplates() {
    const templates = [];
    $(".sb_template-item").each(function () {
        const $item = $(this);
        const id = $item.data("template-preview");
        const name = $item.data("template-name");
        const latitude = $item.data("template-latitude");
        const longitude = $item.data("template-longitude");
        const url = $item.attr("href");

        // Only add templates that have geographic coordinates
        if (id && latitude && longitude) {
            templates.push({
                id: id,
                name: name,
                latitude: parseFloat(latitude),
                longitude: parseFloat(longitude),
                url: url,
            });
        }
    });
    return templates;
}

/**
 * Handle browser back/forward navigation
 */
window.addEventListener("popstate", function (e) {
    // When user navigates back/forward, reload the page to ensure correct state
    // This handles both SSR (no query params) and filtered views (with query params)
    window.location.reload();
});

/**
 * Do on pageload
 */
/**
 * Backwards compatibility: convert old min/max URL params to checkbox selections
 */
function convertLegacyParams() {
    const params = queryString.parse(location.search, {
        arrayFormat: "bracket",
    });

    // Convert old days-min/days-max to days-ranges checkboxes
    if (
        !params["days-ranges"] &&
        params["days-min"] != null &&
        params["days-max"] != null
    ) {
        const oldMin = parseInt(params["days-min"], 10);
        const oldMax = parseInt(params["days-max"], 10);
        $('input[name="days-ranges"]').each(function () {
            const parts = this.value.split("-");
            const rangeMin = parseInt(parts[0], 10);
            const rangeMax = parts[1] === "plus" ? Infinity : parseInt(parts[1], 10);
            const overlaps =
                rangeMax === Infinity
                    ? oldMax >= rangeMin
                    : oldMin <= rangeMax && oldMax >= rangeMin;
            if (overlaps) {
                $(this).prop("checked", true);
            }
        });
    }

    // Convert old budget-min/budget-max to budget-ranges checkboxes
    if (
        !params["budget-ranges"] &&
        params["budget-min"] != null &&
        params["budget-max"] != null
    ) {
        const oldMin = parseInt(params["budget-min"], 10);
        const oldMax = parseInt(params["budget-max"], 10);
        $('input[name="budget-ranges"]').each(function () {
            const parts = this.value.split("-");
            const rangeMin = parseInt(parts[0], 10);
            const rangeMax = parts[1] === "plus" ? Infinity : parseInt(parts[1], 10);
            const overlaps =
                rangeMax === Infinity
                    ? oldMax >= rangeMin
                    : oldMin <= rangeMax && oldMax >= rangeMin;
            if (overlaps) {
                $(this).prop("checked", true);
            }
        });
    }
}

$(function () {
    // Convert legacy URL params to checkbox selections before reading filters
    convertLegacyParams();

    // De klasse op <html> is de weergave: onder `large` heeft
    // `page-templates-filter.twig` de standaardkaart al naar de lijst gezet,
    // en dan hoort de kaart ook niet geladen te worden.
    if ($("html").hasClass("s_view_list")) {
        $("#view").val("list");
    }

    // Read current filters
    readCurrentFilter();
    let query_url =
        filter_url +
        "?" +
        queryString.stringify(current_filters, { arrayFormat: "bracket" });

    // Extract and load server-rendered templates
    const isSsr = window.location.search === "";
    if (isSsr) {
        const serverRenderedTemplates = extractServerRenderedTemplates();
        serverRenderedTemplates.forEach((template) =>
            loaded_templates.push(template)
        );
    } else {
        $("#templates-placeholder-items").removeClass("s_hidden");
    }

    // Update dropdown values on page load
    updateDropdownValues();

    // Enable reset, if applicable
    if (
        (current_filters["destinations"] && current_filters["destinations"] != "all") ||
        (current_filters["days-ranges"] && current_filters["days-ranges"].length > 0) ||
        (current_filters["budget-ranges"] && current_filters["budget-ranges"].length > 0) ||
        (current_filters["template-types"].length > 0 && !(current_filters["template-types"].length === 1 && current_filters["template-types"][0] === "all")) ||
        current_filters["template-kinds"].length > 0
    ) {
        enableReset();
    }

    if (current_filters["view"] == "map") {
        // The map container is display:none until html has s_view_map, and the
        // map refuses to initialize while hidden — set the class first.
        $("html").addClass("s_view_map").removeClass("s_view_list");
        dispatchEvent(new CustomEvent("map:init"));

        // Dispatch the loaded template points once the map is ready
        window.addEventListener("map:ready", () => {
            if (loaded_templates.length > 0) {
                dispatchEvent(
                    new CustomEvent("map:update-points", {
                        detail: { points: loaded_templates },
                    })
                );
            }
        });
    }

    // Query templates regardless of the view, so the list still loads when
    // the map can't (e.g. Mapbox blocked). The map picks up the points via
    // map:update-points once it's ready.
    if (!isSsr) {
        doQuerytemplates(query_url);
    }

});

/**
 * Update dropdown values based on selected filters
 */
function updateDropdownValues() {
    // Get selected template types
    const selectedTemplateTypes = $('input[name="template-types"]:checked')
        .map(function () {
            return $(this).next("label").text().trim();
        })
        .get();

    // Get selected template kinds
    const selectedTemplateKinds = $('input[name="template-kinds"]:checked')
        .map(function () {
            return $(this).next("label").text().trim();
        })
        .get();

    // Get selected template periods
    const selectedTemplatePeriods = $('input[name="template-periods"]:checked')
        .map(function () {
            return $(this).next("label").text().trim();
        })
        .get();

    // Update template types dropdown
    const templateTypesDropdown = $(
        "#templates-filter-template-types-dropdown-values"
    );
    if (templateTypesDropdown.length > 0) {
        if (selectedTemplateTypes.length > 0) {
            templateTypesDropdown.text(selectedTemplateTypes.join(", "));
        } else {
            templateTypesDropdown.text(
                $(
                    '[data-toggle="templates-filter-template-types-dropdown"]'
                ).attr("data-default-text")
            );
        }
    }

    // Update template kinds dropdown
    const templateKindsDropdown = $(
        "#templates-filter-template-kinds-dropdown-values"
    );
    if (templateKindsDropdown.length > 0) {
        if (selectedTemplateKinds.length > 0) {
            templateKindsDropdown.text(selectedTemplateKinds.join(", "));
        } else {
            templateKindsDropdown.text(
                $(
                    '[data-toggle="templates-filter-template-kinds-dropdown"]'
                ).attr("data-default-text")
            );
        }
    }

    // Update template periods dropdown
    const templatePeriodsDropdown = $(
        "#templates-filter-template-periods-dropdown-values"
    );
    if (templatePeriodsDropdown.length > 0) {
        if (selectedTemplatePeriods.length > 0) {
            templatePeriodsDropdown.text(selectedTemplatePeriods.join(", "));
        } else {
            templatePeriodsDropdown.text(
                $(
                    '[data-toggle="templates-filter-template-periods-dropdown"]'
                ).attr("data-default-text")
            );
        }
    }

    // Update days ranges dropdown
    const selectedDaysRanges = $('input[name="days-ranges"]:checked')
        .map(function () {
            return $(this).next("label").text().trim();
        })
        .get();

    const daysRangesDropdown = $(
        "#templates-filter-duration-dropdown-values"
    );
    if (daysRangesDropdown.length > 0) {
        if (selectedDaysRanges.length > 0) {
            daysRangesDropdown.text(selectedDaysRanges.join(", "));
        } else {
            daysRangesDropdown.text(
                $(
                    '[data-toggle="templates-filter-duration-dropdown"]'
                ).attr("data-default-text")
            );
        }
    }

    // Update budget ranges dropdown
    const selectedBudgetRanges = $('input[name="budget-ranges"]:checked')
        .map(function () {
            return $(this).next("label").text().trim();
        })
        .get();

    const budgetRangesDropdown = $(
        "#templates-filter-budget-dropdown-values"
    );
    if (budgetRangesDropdown.length > 0) {
        if (selectedBudgetRanges.length > 0) {
            budgetRangesDropdown.text(selectedBudgetRanges.join(", "));
        } else {
            budgetRangesDropdown.text(
                $(
                    '[data-toggle="templates-filter-budget-dropdown"]'
                ).attr("data-default-text")
            );
        }
    }
}

/**
 * Hide the bars on scroll
 *
 * Omlaag scrollen schuift het menu en de filterbalk weg, omhoog haalt ze terug: samen namen ze
 * op een laptop een derde van het scherm in (CRO-analyse v2). Het wegschuiven zelf zit in de SCSS
 * (`s_bars-hidden`). Alleen vanaf `large`, waar de balken plakken, en niet zolang er een filter
 * openstaat — dat paneel hangt aan de balk en zou mee het beeld uit schuiven.
 */
const BARS_HIDDEN_CLASS = "s_bars-hidden";
// Kleinere bewegingen tellen niet als richting: een trackpad geeft na het loslaten nog wat na.
const BARS_SCROLL_DELTA = 8;
// Bovenaan de pagina blijven de balken staan, ook bij omlaag scrollen.
const BARS_HIDE_AFTER = 300;

let barsLastScrollY = window.scrollY;
let barsFrame = null;

function updateBars() {
    barsFrame = null;

    const scrollY = window.scrollY;
    const delta = scrollY - barsLastScrollY;

    if (Math.abs(delta) < BARS_SCROLL_DELTA) {
        return;
    }

    barsLastScrollY = scrollY;

    const isLarge = window.matchMedia("(min-width: 1025px)").matches;
    const hasOpenPanel = document.querySelector(
        ".dropdown-pane.is-open, .select2-container--open"
    );

    document.body.classList.toggle(
        BARS_HIDDEN_CLASS,
        isLarge && delta > 0 && scrollY > BARS_HIDE_AFTER && !hasOpenPanel
    );
}

/**
 * De meegescrolde filterbalk op mobiel
 *
 * Onder `large` staan de vier filters onder elkaar en zijn ze samen 250px hoog — te veel om te
 * laten plakken. Voorbij de balk gescrold wordt hij daarom één regel bovenaan het scherm: omlaag
 * scrollen schuift hem weg, omhoog haalt hem terug, en de knop klapt de filters eronder uit.
 * Hetzelfde gedrag als de balken op desktop (`updateBars`), alleen dichtgeklapt.
 *
 * `_inner` gaat daarvoor uit de flow, dus de wrapper eromheen krijgt de gemeten hoogte mee —
 * anders springen de reizen erachter een halve pagina omhoog op het moment van vastplakken.
 */
const FILTERS_COMPACT_CLASS = "s_filters-compact";
const FILTERS_VISIBLE_CLASS = "s_filters-visible";
const FILTERS_OPEN_CLASS = "s_filters-open";

const filterBarInner = document.querySelector(
    ".sb_templates-filter_filter-bar_inner"
);
const filterBarWrap = document.querySelector(
    ".sb_templates-filter_filter-bar_inner-wrap"
);

function isCompactViewport() {
    return window.matchMedia("(max-width: 1024px)").matches;
}

function setCompactFilters(compact) {
    const body = document.body;

    if (body.classList.contains(FILTERS_COMPACT_CLASS) === compact) {
        return;
    }

    if (compact) {
        // Meten vóór het uit de flow halen; daarna is de hoogte van de wrapper nul.
        filterBarWrap.style.height = `${filterBarInner.offsetHeight}px`;
    } else {
        filterBarWrap.style.height = "";
        body.classList.remove(FILTERS_VISIBLE_CLASS, FILTERS_OPEN_CLASS);
        setCompactToggleState(false);
    }

    body.classList.toggle(FILTERS_COMPACT_CLASS, compact);
}

function setCompactToggleState(open) {
    document
        .querySelector("[data-toggle-compact-filters]")
        ?.setAttribute("aria-expanded", open ? "true" : "false");
}

// Richting telt pas na 24px, en de balk plakt pas 80px voorbij zijn eigen plek terwijl hij pas
// loslaat op die plek zelf. Zonder die twee marges knipperde hij: op een telefoon levert één veeg
// een reeks kleine bewegingen op, en elke wisseling van teken zette de balk aan of uit (zie de
// schermopname van 17 september 2026).
const FILTERS_DIRECTION_DELTA = 24;
const FILTERS_PIN_MARGIN = 80;

let compactLastScrollY = window.scrollY;
let compactDirectionAnchor = window.scrollY;
let compactDirection = 0;

function updateCompactFilters() {
    if (!filterBarInner || !filterBarWrap) {
        return;
    }

    if (!isCompactViewport()) {
        setCompactFilters(false);
        return;
    }

    const scrollY = window.scrollY;
    const maxScroll =
        document.documentElement.scrollHeight - window.innerHeight;

    // iOS laat de pagina voorbij zijn randen veren; die beweging is geen richting.
    if (scrollY < 0 || scrollY > maxScroll) {
        return;
    }

    const barBottom = filterBarWrap.offsetTop + filterBarWrap.offsetHeight;
    const wasCompact = document.body.classList.contains(FILTERS_COMPACT_CLASS);

    setCompactFilters(
        wasCompact ? scrollY > barBottom : scrollY > barBottom + FILTERS_PIN_MARGIN
    );

    if (!document.body.classList.contains(FILTERS_COMPACT_CLASS)) {
        compactLastScrollY = scrollY;
        compactDirectionAnchor = scrollY;
        compactDirection = 0;
        return;
    }

    // Uitgeklapt blijft hij staan: wegschuiven met een open filter erin laat de bezoeker met een
    // los paneel achter.
    if (document.body.classList.contains(FILTERS_OPEN_CLASS)) {
        compactLastScrollY = scrollY;
        return;
    }

    const delta = scrollY - compactLastScrollY;

    if (delta !== 0 && Math.sign(delta) !== compactDirection) {
        compactDirection = Math.sign(delta);
        compactDirectionAnchor = compactLastScrollY;
    }

    compactLastScrollY = scrollY;

    if (Math.abs(scrollY - compactDirectionAnchor) < FILTERS_DIRECTION_DELTA) {
        return;
    }

    document.body.classList.toggle(
        FILTERS_VISIBLE_CLASS,
        compactDirection < 0
    );
}

/**
 * Het aantal actieve filters op de knop
 *
 * Dichtgeklapt is niet te zien dát er gefilterd is, dus het aantal gekozen waarden staat erop.
 */
function updateActiveFiltersCount() {
    // Alleen filters die de bezoeker ook kan zien: de verborgen blokken (reisvorm, reisperiode)
    // staan er nog voor URL-filters en hebben hun eigen aangevinkte waarden.
    const checked = Array.from(
        document.querySelectorAll(
            '.sb_templates-filter_filter-block input[type="checkbox"]:checked'
        )
    ).filter((input) => !input.closest(".sb_templates-filter_filter-block.s_hidden"));

    // De bestemmingen zijn een select; de lege optie is de rustwaarde en telt niet mee.
    const destinations = Array.from(
        document.querySelectorAll("#templates-destinations option:checked")
    ).filter((option) => option.value !== "");

    const count = checked.length + destinations.length;

    const badge = document.querySelector("[data-active-filters-count]");

    if (!badge) {
        return;
    }

    badge.textContent = count;
    badge.classList.toggle("s_hidden", count === 0);
}

if (document.querySelector('[data-s-type="templates-filter"]')) {
    document
        .querySelector("[data-toggle-compact-filters]")
        ?.addEventListener("click", () => {
            const open = document.body.classList.toggle(FILTERS_OPEN_CLASS);

            setCompactToggleState(open);
        });

    updateActiveFiltersCount();

    // Elke filterwijziging herlaadt de lijst via `data-templates-filter`; het aantal op de knop
    // volgt dezelfde gebeurtenissen.
    $(document).on(
        "change",
        '.sb_templates-filter_filter-block input[type="checkbox"], #templates-destinations',
        updateActiveFiltersCount
    );

    window.addEventListener(
        "scroll",
        () => {
            if (barsFrame === null) {
                barsFrame = requestAnimationFrame(() => {
                    updateBars();
                    updateCompactFilters();
                });
            }
        },
        { passive: true }
    );

    // Draaien van het toestel verandert de hoogte van de balk; de vastgezette wrapperhoogte moet
    // dan opnieuw gemeten worden.
    window.addEventListener("resize", () => {
        if (document.body.classList.contains(FILTERS_COMPACT_CLASS)) {
            setCompactFilters(false);
        }
    });

    // De kaart verandert van hoogte zodra de balken komen of gaan, maar Mapbox volgt alleen het
    // venster: zonder dit event bleef het canvas op zijn oude hoogte en viel er onderaan een gat.
    document
        .querySelector(".sb_templates-filter_map")
        ?.addEventListener("transitionend", (event) => {
            if (event.propertyName === "height") {
                window.dispatchEvent(new Event("resize"));
            }
        });
}
